import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useStartAuth = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/Authentication/StartLogin", formData);
  });
  return mutation;
};
export default useStartAuth;
